<!--操作计划-->
<template>
  <div class="add_order">
    <head-panel title="广告投放" subtitle="AD SERVING" :exportExc="false"></head-panel>
    <div class="formPanel">
      <h3 class="subTit"></h3>
      <el-form
        class="ruleForm"
        :model="order"
        :rules="rules"
        ref="order"
        label-width="12%"
        v-loading="loading"
      >
        <el-form-item label="广告主名称" prop="advertiser">
          <ny-select
            :data="orderManage.advertiserMenu"
            v-model="order.advertiser"
            @change="changeSelect"
            type="advertiser"
            placeholder="请选择"
            :filterable="true"
            :disabled="!isAdd"
          ></ny-select>
        </el-form-item>
        <el-form-item label="计划名称" prop="name">
          <el-input v-model="order.name" class="taskInput" type="age" placeholder="请输入计划名称"></el-input>
        </el-form-item>
        <el-form-item label="流量类型" prop="flowType">
          <el-radio-group v-model="order.flowType" @change="flowTypeChange" :disabled="!isAdd">
            <el-radio
              :label="item.value"
              v-for="(item,key) in orderManage.flowTypeMenu"
              :key="key"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="投放终端" prop="portType">
          <el-radio-group v-model="order.portType" @change="portTypeChange" :disabled="!isAdd">
            <el-radio
              :label="item.value"
              v-for="(item,key) in orderManage.portTypeMenu"
              :key="key"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="媒体名称" prop="media" v-if="isMediaShow">
          <el-radio-group
            v-model="order.media"
            @change="mediaChange"
            class="rule_form_radio"
            v-if="mediaType === 'radio'"
          >
            <el-radio
              :label="item.value"
              v-for="(item,key) in orderManage.mediaMenu"
              :key="key"
              :disabled="!isAdd"
            >{{item.name}}</el-radio>
          </el-radio-group>
          <el-checkbox-group
            v-model="order.media"
            v-if="mediaType === 'checkbox'"
            class="ny-order__checkbox"
            @change="mediaChange"
          >
            <el-checkbox
              v-for="(item, key) in orderManage.mediaMenu"
              :label="item.value"
              :key="key"
              :disabled="!isAdd"
            >{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="渠道名称" prop="channelName" v-if="isMediaShow">
          <el-radio-group
            v-model="order.channelName"
            @change="channelNameChange"
            class="rule_form_radio"
            v-if="mediaType === 'radio'"
          >
            <el-radio
              :label="item.value"
              v-for="(item,key) in orderManage.channelNameMenu"
              :key="key"
              :disabled="!isAdd"
            >{{item.name}}</el-radio>
          </el-radio-group>
          <ny-form-item-checkbox
            multiple
            v-if="mediaType === 'checkbox'"
            v-model="order.channelName"
            :disabled="!isAdd"
            :data="orderManage.channelNameMenu"
            @change="channelNameChange"
          ></ny-form-item-checkbox>
          <!-- <el-checkbox-group v-model="order.channelName" @change="channelNameChange">
            <el-checkbox
              v-for="(item, key) in orderManage.channelNameMenu"
              :label="item.value"
              :key="key"
              :disabled="!isAdd"
            >{{item.name}}</el-checkbox>
          </el-checkbox-group>-->
        </el-form-item>
        <el-form-item label="广告位属性" prop="placeAttr">
          <el-radio-group
            v-model="order.placeAttr"
            @change="placeAttrChange"
            class="rule_form_radio"
            :disabled="!isAdd"
          >
            <el-radio
              :label="item.value"
              v-for="(item,key) in orderManage.placeAttrMenu"
              :key="key"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="广告位" prop="position" class="position" v-if="mediaType === 'radio'">
          <el-col v-if="isChannelTypeShow">
            <ny-select
              :data="orderManage.channelTypeMenu"
              v-model="order.channelType"
              :keyValue="['value', 'name']"
              @change="changeSelect"
              type="channelType"
              placeholder="请选择"
              class="input_sm"
              :disabled="!isAdd"
            ></ny-select>
          </el-col>
          <el-col v-if="isChannelShow">
            <ny-select
              :data="orderManage.channelMenu"
              v-model="order.channel"
              :keyValue="['value', 'name']"
              @change="changeSelect"
              type="channel"
              placeholder="请选择"
              class="input_sm"
              :disabled="!isAdd"
            ></ny-select>
          </el-col>
          <el-col>
            <!--<ny-select
              :data="orderManage.positionMenu"
              v-model="order.position = orderManage.curPosition"
              :keyValue="['value', 'name']"
              @change="changeSelect"
              type="position"
              placeholder="请选择"
              class="input_sm"
            ></ny-select>-->
            <el-select
              v-model="order.position"
              placeholder="请选择"
              @change="changeSelect1"
              filterable
              :disabled="!isAdd"
            >
              <el-option
                v-for="item in orderManage.positionMenu"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="优先级" prop="prority">
          <ny-select
            :data="orderManage.prorityMenu"
            v-model="order.prority"
            type="advertiser"
            placeholder="请选择"
            :disabled="!isAdd"
          ></ny-select>
        </el-form-item>
        <el-form-item label="结算方式" prop="payment" v-if="order.prority !== '40'">
          <el-radio-group
            v-model="order.payment"
            @change="paymentChange"
            class="rule_form_radio"
            :disabled="!isAdd"
          >
            <el-radio
              :label="item.value"
              v-for="(item,key) in orderManage.paymentMenu"
              :key="key"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="轮播" prop="carousel" v-if="false">
          <el-radio-group v-model="order.carousel" @change="carouselChange" class="rule_form_radio">
            <el-radio
              :label="item.value"
              v-for="(item,key) in orderManage.carouselMenu"
              :key="key"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item
          :label="order.payment === 'cpc' ? '点击量' : '投放量'"
          prop="putNum"
          v-if="!isCarouselShow"
        >
          <el-input
            v-model.number="order.putNum"
            class="taskInput"
            type="age"
            :placeholder="order.payment === 'cpc' ? '请输入点击量' : '请输入投放量'"
          ></el-input>
        </el-form-item>-->
        <!-- <el-form-item label="日预算" prop="budget">
          <el-input
            v-model="order.budget"
            class="taskInput"
            type="age"
            placeholder="请输入日预算"
            @input.native="changeComdify('order' ,'budget')"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>-->
        <!-- <el-form-item label="结算单价" prop="paymentMount" v-if="!isCarouselShow">
          <el-input
            v-model="order.paymentMount"
            class="taskInput"
            type="age"
            placeholder="请输入结算单价"
            @input.native="changeComdify('order' ,'paymentMount')"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>-->
        <el-form-item label="曝光频次" class="labelAfter i-question-box">
          <el-tooltip class="item" effect="light" placement="right">
            <div slot="content">每人每天曝光控制</div>
            <i class="icon iconfont icon-iconfontquestion"></i>
          </el-tooltip>
          <el-input
            v-model="order.cpmNum"
            class="taskInput"
            type="age"
            placeholder="请输入曝光频次"
            @input.native="changeCode('cpmNum')"
          ></el-input>
        </el-form-item>
        <el-form-item label="点击频次" class="labelAfter i-question-box">
          <el-tooltip class="item" effect="light" placement="right">
            <div slot="content">每人每天点击控制</div>
            <i class="icon iconfont icon-iconfontquestion"></i>
          </el-tooltip>
          <el-input
            v-model="order.clickNum"
            class="taskInput"
            type="age"
            placeholder="请输入点击频次"
            @input.native="changeCode('clickNum')"
          ></el-input>
        </el-form-item>
        <el-form-item class="btnGroups">
          <el-button
            v-if="!isShow"
            size="large"
            type="primary"
            @click="submitForm('order')"
            :disabled="committing"
          >{{committing ? '提交中···' : '提交'}}</el-button>
          <el-button size="large" class="is-cancel" @click="cancel">{{isShow ? '返回': '取消'}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { headPanel, NySelect, NyFormItemCheckbox } from '@/global/components'
import { post, get, put } from '@/manager/http/index'
import { comdify, delcommafy } from '@/global/util/util'
export default {
  data() {
    let validateOrderName = (rule, value, callback) => {
      let self = this
      if (value === '') {
        callback(new Error('请输入计划名称'));
      } else if (value.length > 50) {
        callback(new Error('输入内容不得超过50个字符'));
      } else {
        this.isRepeatOrderName().then(res => {
          if (res && value !== self.editOrderName) {
            callback(new Error('计划名称已存在，请重新输入'))
          }
          callback();
        })
      }
    };
    let validateBudget = (rule, value, callback) => {
      let reg = /^[0-9]*$/
      if (value === '') {
        callback(new Error('请输入日预算'));
      } else if (!reg.test(delcommafy(value))) {
        callback(new Error('请输入数字'))
      } else {
        if (delcommafy(value) < 100) {
          callback(new Error('日预算最低100元'))
        } else if (delcommafy(value) > 9999999 || delcommafy(value) < 1) {
          callback(new Error('输入的日预算需不超过9999999'))
        }
        callback();
      }
    };
    let valCity = (rule, value, callback) => {
      let self = this
      setTimeout(function () {
        if (self.order.curCity.length === 0) {
          callback(new Error('请选择投放地域'));
        } else {
          callback();
        }
      }, 100)
    };
    let paymentMount = (rule, value, callback) => {
      let reg = /^[0-9]*$/
      if (value === '') {
        callback(new Error('请输入结算单价'));
      } else if (!reg.test(delcommafy(value))) {
        callback(new Error('请输入数字'))
      } else if (delcommafy(value) > 9999999 || delcommafy(value) < 1) {
        callback(new Error('输入的结算单价需大于0且不超过9999999'))
      } else {
        callback();
      }
    };
    /*  let validatePutNum = (rule, value, callback) => {
       let reg = /^[0-9]*$/
       this.$refs['order'].rules.putNum[0].required = this.order.payment !== 'cpc'
       if (value === '') {
         if (this.order.payment === 'cpc') {
           callback();
         } else {
           let message = this.order.payment === 'cpc' ? '请输入点击量' : '请输入投放量'
           callback(new Error(message));
         }
       } else if (!reg.test(value)) {
         callback(new Error('请输入数字'))
       } else if (parseInt(value) > 1000000000) {
         callback(new Error('投放量不得超过10亿'))
       } else {
         callback();
       }
     }; */
    let validateMedia = (rule, value, callback) => {
      if (value === '' || value.length < 1) {
        callback(new Error('请选择媒体名称'))
      } else {
        callback()
      }
    }
    let validateChannelName = (rule, value, callback) => {
      if (value === '' || value.length < 1) {
        callback(new Error('请选择渠道名称'))
      } else {
        callback()
      }
    }
    return {
      order_title: '',
      platform: '',
      os_list: '',
      isChannelTypeShow: false,
      isChannelShow: false,
      isCarouselShow: false,
      isMediaShow: true, // 媒体是否展示
      isAdd: true,
      isShow: false,
      loading: false,
      isDetails: false,
      committing: false, // 是否正在提交
      editOrderName: '', // 编辑验证计划名称
      detailInfo: [], // 查看或编辑时 地区数据
      defaultDate: [], // 默认时间范围
      type: '', // 页面类型
      receiveData: [], // 查看/编辑时 已经选择的时间范围
      receiveDateRange: [], // 查看/编辑时 已经选择的日期范围
      mediaType: 'radio', // 媒体类型
      api: 'order', // 区分媒体单选和通投标识
      order: {
        advertiser: '',
        name: '',
        flowType: undefined,
        media: '',
        portType: '',
        placeAttr: '',
        position: '',
        curCity: [],
        date: [],
        time: [],
        payment: '',
        carousel: '',
        putNum: '',
        paymentMount: '',
        budget: '',
        cpmNum: '',
        clickNum: '',
        channelName: '',
        prority: '30' // 优先级
      },
      rules: {
        advertiser: [
          { required: true, message: '请选择广告主', trigger: 'blur' }
        ],
        name: [{ required: true, validator: validateOrderName, trigger: 'blur' }],
        flowType: [{ required: true, message: '请选择流量类型', trigger: 'change' }],
        portType: [{ required: true, message: '请选择投放终端', trigger: 'change' }],
        media: [{ required: true, validator: validateMedia, trigger: 'change' }],
        placeAttr: [{ required: true, message: '请选择广告位属性', trigger: 'change' }],
        position: [{ required: true, message: '请选择广告位', trigger: 'change' }],
        curCity: [{ type: 'array', required: true, validator: valCity, trigger: 'change' }],
        time: [{ type: 'array', required: true, message: '请选择推广周期', trigger: 'change' }],
        payment: [{ required: true, message: '请选择结算方式', trigger: 'change' }],
        carousel: [{ required: true, message: '请选择轮播方式', trigger: 'change' }],
        prority: [{ required: true, message: '请选择优先级', trigger: 'change' }],
        channelName: [{ required: true, validator: validateChannelName, trigger: 'change' }],
        paymentMount: [{ required: true, validator: paymentMount, trigger: 'blur' }],
        // putNum: [{ required: true, validator: validatePutNum, trigger: 'blur' }],
        budget: [{ required: true, validator: validateBudget, trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters({
      orderManage: 'orderManage',
      userid: 'login/userid'
    })
  },
  async created() {
    this.loading = true
    this.platform = this.$router.currentRoute.meta.platform;
    this.isCarouselShow = (this.order.payment === 'cpt' && this.$route.params.media === 'radio')
    this.isShow = this.$route.params.type === 'show'
    this.isAdd = !this.$route.params.id
    this.order_title = this.$route.params.id ? (this.isShow ? '查看' : '编辑') : '添加'
    this.mediaType = this.$route.params.media
    this.$store.commit('ORDER_CHANGE_MEDIA_TYPE', { type: this.$route.params.media })
    this.isMediaShow = this.$route.params.media !== 'global'
    this.api = this.$route.params.media !== 'radio' ? 'global-order' : 'order'
    await this.init()
    this.loading = false
  },
  methods: {
    async init() {
      this.getAdvertiserList()
      await this.$store.dispatch('getCommonPlace', {
        params: 'flow_type',
        data: {
          platform: this.platform
        },
        api: 'ORDER_FLOW_TYPE_MENU'
      })
      await this.$store.dispatch('proritySelect')
      this.order.flowType = this.orderManage.curFlowType
      this.getPortTypeMenu(this.order.flowType)
      await this.$store.dispatch('getCommonPlace', {
        params: 'channel_type',
        data: {
          platform: this.platform
        },
        api: 'ORDER_CHANNEL_TYPE_MENU'
      })
      this.order.channelType = this.orderManage.curChannelType
      this.getChannelMenu(this.orderManage.curChannelType)
      this.order.portType = this.orderManage.curPortType
      if (this.$route.params.id) {
        await this.getOrderDetails()
        this.isDetails = true
      }
    },
    getAdvertiserList() { // 获取广告主列表数据
      this.$store.dispatch('advertiserList')
    },
    async getOrderDetails() {
      await get('/admin/' + this.api + '/' + this.$route.params.id).then(async res => {
        if (res.code === 1) {
          let data = res.data
          let isAdver = this.orderManage.advertiserMenu.find((item, index) => {
            return item.value === data.advertiser_id
          })
          if (isAdver === undefined) {
            this.orderManage.advertiserMenu.push({
              name: data.advertiser_name,
              value: data.advertiser_id
            })
          }
          this.order.advertiser = data.advertiser_id
          this.order.name = data.order_name
          if (this.$route.params.type === 'edit') {
            this.editOrderName = data.order_name
          }
          this.order.flowType = data.flow_type
          this.order.portType = data.port_type
          this.order.media = data.media
          this.order.prority = data.prority
          this.getPortTypeMenu()
          this.order.channelName = data.media_channel_id ? data.media_channel_id : data.medias
          if (!data.media) {
            await this.getPlaceAttrMenu({ media: data.medias })
          }
          this.order.placeAttr = data.place_attribute
          this.order.channelType = data.channel_type
          this.order.channel = data.channel
          await this.getChannelMenu(this.order.channelType)
          this.order.position = data.place_id
          this.order.payment = data.payment
          this.order.carousel = data.carousel
          this.detailInfo = data.provinces
          this.order.paymentMount = comdify(parseInt(data.pay_univalent))
          // this.order.putNum = parseInt(data.throw_num)
          this.order.budget = comdify(parseInt(data.budget))
          this.order.cpmNum = parseInt(data.cpm_num)
          this.order.clickNum = parseInt(data.click_num)
        }
      })
      // if (this.order.payment !== 'cpt') { this.$refs['order'].validateField('putNum') }
    },
    async getPortTypeMenu({ flowType, def } = {}) {
      await this.$store.dispatch('getCommonPlace', {
        params: 'port_type',
        data: {
          platform: this.platform,
          flow_type: flowType || this.order.flowType
        },
        api: 'ORDER_PORT_TYPE_MENU'
      })
      if (this.isAdd) { this.order.portType = this.orderManage.curPortType }
      await this.getMediaMenu()
    },
    async getMediaMenu({ flowType, portType, def } = {}) {
      await this.$store.dispatch('getCommonPlace', {
        params: 'media',
        data: {
          platform: this.platform,
          port_type: portType || this.order.portType,
          flow_type: flowType || this.order.flowType,
          advertiser_id: this.order.advertiser
        },
        api: 'ORDER_MEDIA_MENU',
        mediaType: this.mediaType
      })
      if (this.isAdd) { this.order.media = this.orderManage.curMedia }
      await this.getChannelName()
    },
    async getChannelName({ flowType, portType, def, media } = {}) {
      await this.$store.dispatch('getCommonPlace', {
        params: 'media_channel_id',
        data: {
          platform: this.platform,
          port_type: portType || this.order.portType,
          flow_type: flowType || this.order.flowType,
          media: media || this.order.media,
          advertiser_id: this.order.advertiser
        },
        api: 'ORDER_CHANGE_NAME_MENU',
        mediaType: this.mediaType
      })
      if (this.isAdd) { this.order.channelName = this.orderManage.curChannelName }
      await this.getPlaceAttrMenu()
    },
    async getPlaceAttrMenu({ flowType, portType, media, def, mediaType } = {}) {
      await this.$store.dispatch('getCommonPlace', {
        params: 'place_attribute',
        data: {
          platform: this.platform,
          port_type: portType || this.order.portType,
          media_channel_id: media || this.order.channelName,
          flow_type: flowType || this.order.flowType,
          advertiser_id: this.order.advertiser
        },
        api: 'ORDER_PLACE_ATTRIBUTE_MENU',
        mediaType: this.mediaType
      })
      if (this.isAdd) { this.order.placeAttr = this.orderManage.curPlaceAttr }
      await this.getPositionMenu()
    },
    async getChannelMenu(api) {
      await this.$store.dispatch('getCommonPlace', {
        params: 'channel',
        data: {
          channel_type: api || this.order.channelType,
          platform: this.platform
        },
        api: 'ORDER_CHANNEL_MENU'
      })
      if (this.isAdd) { this.order.channel = this.orderManage.curChannel }
      await this.getPositionMenu()
    },
    async getPositionMenu() {
      if (this.mediaType !== 'radio') {
        this.getPayment()
        return false
      }
      let arr = [this.order.flowType, this.order.portType, this.order.channelName, this.order.placeAttr]
      let isEmpty = true
      arr.forEach(res => {
        if (res === '') {
          isEmpty = false
          return false
        }
      })
      this.isChannelTypeShow = (this.order.media === '1' && this.order.placeAttr === '2' && this.order.flowType === '1')
      this.isChannelShow = this.isChannelTypeShow && this.order.channelType !== '3'
      if (isEmpty) {
        let params = {
          flow_type: this.order.flowType,
          port_type: this.order.portType,
          media_channel_id: this.order.channelName,
          place_attribute: this.order.placeAttr,
          advertiser_id: this.order.advertiser
        }
        if (this.order.media === '1' && this.order.placeAttr === '2' && this.order.flowType === '1') {
          params.channel_type = this.order.channelType
          if (this.order.channelType !== '3') {
            params.channel = this.order.channel
          }
        }
        // await this.$store.dispatch('getPosition', { params })
        await this.$store.dispatch('getCommonPlace', {
          params: 'places',
          data: params,
          api: 'ORDER_POSITION_MENU'
        })
        if (this.isAdd) { this.order.position = this.orderManage.curPosition }
        this.getPayment()
      } else {
        return false
      }
    },
    async getPayment() {
      let api = 'payment-radio'
      let params = {}
      if (this.mediaType !== 'radio') {
        if (!this.order.placeAttr && !this.order.channelName) { return false }
        api = 'payment-reelection'
        params = {
          flow_type: this.order.flowType,
          advertiser_id: this.order.advertiser,
          port_type: this.order.portType,
          medias: this.mediaType === 'global' ? -1 : this.order.channelName ? this.order.channelName.join(',') : '',
          place_attribute: this.order.placeAttr
        }
      } else {
        params.advertiser_id = this.order.advertiser
        params.place_id = this.order.position
        params.platform = this.platform
      }
      if (!this.order.position) { return false }
      await this.$store.dispatch('getEtcdItem', {
        params: api,
        data: params,
        mediaType: this.mediaType,
        api: 'ORDER_PAYMENT_MENU'
      })
      if (this.isAdd) {
        this.order.payment = this.orderManage.paymentMenu.length ? this.orderManage.paymentMenu[0].value : ''
      }
    },
    paymentChange() { },
    async isRepeatOrderName() { // 判断计划是否重名
      let flag = false
      if (this.order.name !== '') {
        await this.$store.dispatch('orderNameIsRepeat', { data: this.order.name, mediaType: this.mediaType }).then((data) => {
          if (data && data.code === 1 && data.data.status === 1) {
            flag = true
          } else {
            flag = false
          }
        })
      }
      return flag
    },
    changeSelect({ value, type }) {
      if (type === 'channel' || type === 'channelType') {
        if (type === 'channelType') {
          this.getChannelMenu(this.order.channelType)
        } else {
          this.getPositionMenu()
        }
      } else if (type === 'advertiser') {
        this.getMediaMenu()
      }
    },
    changeSelect1(value) {
      this.getPayment()
    },
    changeCode(name) {
      this.$nextTick(() => {
        if (this.order[name] !== null) {
          this.order[name] = this.order[name].replace(/[^\d]/g, '')
        }
      })
    },
    changeComdify(form, name) {
      this.$nextTick(() => {
        if (this[form][name] !== null) {
          this[form][name] = comdify(delcommafy(this[form][name]))
        }
      })
    },
    flowTypeChange(value) {
      this.getPortTypeMenu()
    },
    portTypeChange(value) {
      this.getMediaMenu()
    },
    mediaChange(value) {
      this.getChannelName()
    },
    channelNameChange(value) {
      this.getPlaceAttrMenu()
      if (typeof value === 'object') {
        let data = []
        this.orderManage.channelNameMenu.filter(item => {
          value.forEach(res => {
            if (item.value === res && data.indexOf(item.pMedia) < 0) {
              data.push(item.pMedia)
            }
          })
        })
        // this.order.media = [...data]
      }
    },
    placeAttrChange(value) {
      this.getPositionMenu()
    },
    handleChange(type, value) { //
      this.order.curCity = value
    },
    selectedCycle({ date, formatDate, dateCycle }) {
      this.order.date = [...dateCycle]; // 已选择日期范围
      this.order.time = date; // 已选择日期对应的时间范围
      this.receiveData = this.dataFilter(date)
      this.receiveDateRange = this.order.date
      this.$refs['order'].validateField('date')
    },
    dataFilter(date) {
      let arr = []
      date.forEach(time => {
        let temp = []
        time.time.forEach(t => {
          if (t.length === 1) {
            temp.push(t < 10 ? ['0' + t, '0' + (parseInt(t) + 1)] : [t + '', (parseInt(t) + 1) + ''])
          } else {
            temp.push(t.map((v, i) => {
              if (i === 1) {
                v = parseInt(v) + 1
              }
              return v < 10 ? '0' + parseInt(v) : v + ''
            }))
          }
        })
        arr.push({
          date: time.date,
          time: temp
        })
      })
      return arr
    },
    getParams() {
      let params = {
        advertiser_id: this.order.advertiser,
        order_name: this.order.name,
        flow_type: this.order.flowType,
        port_type: this.order.portType,
        place_attribute: this.order.placeAttr,
        channel_type: this.order.channelType,
        channel: this.order.channel,
        place_id: this.order.position,
        payment: this.order.payment,
        carousel: 0,
        budget: delcommafy(this.order.budget),
        // throw_num: this.order.putNum,
        cpm_num: this.order.cpmNum,
        click_num: this.order.clickNum,
        prority: this.order.prority
      }
      if (!this.isCarouselShow) {
        params.pay_univalent = parseInt(delcommafy(this.order.paymentMount))
      }
      let key = this.mediaType !== 'radio' ? 'medias' : 'media_channel_id'
      params[key] = this.mediaType === 'global' ? new Array('-1') : this.order.channelName
      return params
    },
    submitForm(numberValidateForm) {
      this.$refs[numberValidateForm].validate((valid) => {
        if (valid) {
          let api = this.mediaType !== 'radio' ? 'global-order' : 'order'
          this.committing = true
          let self = this
          let data = self.getParams()
          if (self.$route.params.id && self.$route.params.type === 'edit') {
            put('/admin/' + api + '/' + self.$route.params.id, data).then(res => {
              if (res.code === 1) {
                this.committing = false
                self.$message('提交成功')
                self.$router.push('/orderList/nofilter')
              } else {
                this.committing = false
                self.$message.error(res.msg)
              }
            }).catch(() => {
              this.committing = false
            })
            return false
          }
          post('/admin/' + api, data).then(res => {
            if (res.code === 1) {
              this.committing = false
              self.$message('提交成功')
              self.$router.push('/orderList/nofilter')
            } else {
              self.$message.error(res.msg)
              this.committing = false
            }
          }).catch(() => {
            this.committing = false
          })
        }
      });
    },
    cancel() {
      this.$router.push('/orderList/nofilter');
    }
  },
  components: {
    headPanel,
    NySelect,
    NyFormItemCheckbox
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.add_order {
  position: relative;
  .ruleForm {
    .input_sm {
      width: 210px;
      .el-select {
        width: 210px;
      }
    }
    .input_lg {
      width: 350px;
    }
    .ml16 {
      margin-left: 16px;
    }
    .mr20 {
      margin-right: 20px;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
    .btnGroups {
      text-align: left;
      margin-left: 16px;
    }
  }
  .rule_form_radio {
    max-width: 850px;
    text-align: left;
    .el-radio {
      line-height: 30px;
      margin-left: 0;
      margin-right: 16px;
    }
  }
  .position {
    .el-col {
      width: 210px;
      margin-right: 20px;
    }
  }
  .date-panel-2 .finallyDate {
    margin-left: 16px;
  }
  .date-panel-2 .date-range2 {
    left: 16px;
  }
  .order-area .put-area {
    display: inline-block;
  }
  .goList {
    color: #65cea7;
    cursor: pointer;
  }
  .i-question-box {
    position: relative;
    .icon-iconfontquestion {
      position: absolute;
      top: 1px;
      left: -10px;
      color: #fc8675;
      cursor: pointer;
    }
  }
}
</style>
